import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Spinner, Alert } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.scss";
import moment from "moment";
import { config } from "../../App";
import SuccessModal from "../../utilities/SuccessModal";

function RegisterEmp(props) {
    const navigate = useNavigate();

    const [empId, setEmpId] = useState("");
    const [dob, setDob] = useState(null);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [otp, setOtp] = useState("");

    const [empIdError, setEmpIdError] = useState("");
    const [dobError, setDobError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [otpError, setOtpError] = useState("");
    const [apiError, setApiError] = useState("");
    const [successMsg, setSuccessMsg] = useState("");

    const [step, setStep] = useState("initial");
    const [loading, setLoading] = useState(false);
    const [resendEnabled, setResendEnabled] = useState(false);
    const [timer, setTimer] = useState(0);

    const [successMessage, setSuccessMessage] = useState("");
    const [successModal, setSuccessModal] = useState(false);

    const [passwordVisible, setPasswordVisible] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const employeeIdRegex = /^(?:(?:EMP|ECN|SG)?\d{4,10}|[a-zA-Z0-9._%+-]{1,}[@][a-zA-Z0-9.-]{2,}\.[a-zA-Z]{2,})$/i;

    useEffect(() => {
        let interval;
        if (timer > 0) {
            interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
        } else if (timer === 0) {
            setResendEnabled(true);
        }
        return () => clearInterval(interval);
    }, [timer]);

    const validateEmployeeId = (value) => {
        const trimmed = value.trim();
        if (!trimmed) return "Employee ID or Email is required.";
        // if (!employeeIdRegex.test(trimmed)) {
        //     if (trimmed.includes("@")) {
        //         return "Please enter a valid email address";
        //     }
        //     return "Invalid Employee ID format.";
        // }
        return "";
    };

    const formatDob = (date) => {
        if (!date) return "";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    };

    const canSendOtp =
        !loading &&
        !empIdError &&
        empId.trim() &&
        !!dob &&
        !dobError;

    const canCompleteRegistration =
        !loading &&
        !passwordError &&
        !confirmPasswordError &&
        !otpError &&
        password.length >= 8 &&
        password.length <= 16 &&
        password === confirmPassword &&
        otp.length === 6;

    const handleEmpIdChange = (e) => {
        const val = e.target.value;
        setEmpId(val);
        setEmpIdError(validateEmployeeId(val));
        setApiError("");
    };

    const handleDobChange = (date) => {
        setDob(date);
        setDobError(date ? "" : "Please select Date of Birth.");
        setApiError("");
    };

    const handlePasswordChange = (e) => {
        const val = e.target.value;
        setPassword(val);

        if (!val) {
            setPasswordError("Password is required.");
        } else if (val.length < 8) {
            setPasswordError("Password must be at least 8 characters.");
        } else if (val.length > 16) {
            setPasswordError("Password cannot exceed 16 characters.");
        } else if (!/[A-Z]/.test(val)) {
            setPasswordError("Must contain at least one uppercase letter.");
        } else if (!/[a-z]/.test(val)) {
            setPasswordError("Must contain at least one lowercase letter.");
        } else if (!/\d/.test(val)) {
            setPasswordError("Must contain at least one number.");
        } else if (!/[@#$%^&*_+=-]/.test(val)) {
            setPasswordError("Must contain at least one special character (@#$%^&*_+=-)");
        } else {
            setPasswordError("");
        }

        if (confirmPassword && confirmPassword !== val) {
            setConfirmPasswordError("Passwords do not match.");
        } else if (confirmPassword) {
            setConfirmPasswordError("");
        }
    };

    const handleConfirmPasswordChange = (e) => {
        const val = e.target.value;
        setConfirmPassword(val);

        if (!val) {
            setConfirmPasswordError("Please confirm your password.");
        } else if (val !== password) {
            setConfirmPasswordError("Passwords do not match.");
        } else {
            setConfirmPasswordError("");
        }
    };

    const handleOtpChange = (e) => {
        const val = e.target.value.replace(/\D/g, "").slice(0, 6);
        setOtp(val);

        if (!val) {
            setOtpError("Please enter OTP.");
        } else if (val.length < 6) {
            setOtpError("OTP must be exactly 6 digits.");
        } else {
            setOtpError("");
        }
    };

    const handleSendOTP = async (req) => {
        const eidErr = validateEmployeeId(empId);
        setEmpIdError(eidErr);
        setDobError(!dob ? "Please select Date of Birth." : "");

        if (eidErr || !dob) return;

        setLoading(true);
        setApiError("");

        try {
            const res = await axios.post(`${config.endpoint}/auth/register`, {
                username: empId.trim(),
                dob: formatDob(dob),
                // dob: "02/18/2000",
                //dob: moment(dob, "DD-MMM-YYYY").format("DD-MM-YYYY"),
                ResendOTP: req,
            });

            if (res.data.status === true) {
                setStep("otp");
                setResendEnabled(false);
                setTimer(180);
                setSuccessMsg("OTP sent to your registered email");
                setApiError("");
            } else {
                setApiError(res.data.ResponseMessage || "Failed to send OTP");
                //props.setActiveTab("login");
            }
        } catch (err) {
            setApiError(err.response?.data?.ResponseMessage || "Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    const handleResendOTP = () => {
        handleSendOTP(true);
    }

    const handleCompleteRegistration = async () => {
        let hasError = false;

        if (!password) {
            setPasswordError("Password is required.");
            hasError = true;
        } else if (password.length < 8 || password.length > 16) {
            setPasswordError("Password must be 8 to 16 characters long.");
            hasError = true;
        } else if (!/[A-Z]/.test(password)) {
            setPasswordError("Must contain at least one uppercase letter.");
            hasError = true;
        } else if (!/[a-z]/.test(password)) {
            setPasswordError("Must contain at least one lowercase letter.");
            hasError = true;
        } else if (!/\d/.test(password)) {
            setPasswordError("Must contain at least one number.");
            hasError = true;
        } else if (!/[@#$%^&*_+=-]/.test(password)) {
            setPasswordError("Must contain at least one special character.");
            hasError = true;
        }

        if (!confirmPassword) {
            setConfirmPasswordError("Please confirm your password.");
            hasError = true;
        } else if (confirmPassword !== password) {
            setConfirmPasswordError("Passwords do not match.");
            hasError = true;
        }

        if (otp.length !== 6) {
            setOtpError("OTP must be exactly 6 digits.");
            hasError = true;
        }

        if (hasError) return;

        setLoading(true);
        setApiError("");

        try {
            const res = await axios.post(`${config.endpoint}/auth/verifyRegistration`, {
                username: empId.trim(),
                password,
                otp,
            });

            if (res.data.status === true) {
                setSuccessMessage(res.data.ResponseMessage);
                setSuccessModal(true);
                // props.setActiveTab("login");
                props.setIsSignin(false);
            } else {
                setApiError(res.data.ResponseMessage || "Verification failed");
            }
        } catch (err) {
            setApiError(err.response?.data?.ResponseMessage || "Verification failed.");
        } finally {
            setLoading(false);
        }
    };

    const formatTimer = (seconds) => {
        const min = Math.floor(seconds / 60);
        const sec = seconds % 60;
        return `${min}:${sec < 10 ? "0" : ""}${sec}`;
    };

    const closeSuccessModal = () => {
        setSuccessModal(false);
        navigate(`/login`)
    }

    return (
        <>
            {/*  <section className="login-wrapper d-flex align-items-center">
             <Container>
                 <div className="login-card shadow-lg">
                    <Row className="g-0"> */}
            {/* <Col lg={6} className="left-panel d-none d-lg-block">
                            <div className="left-content">
                                <h2>Employee <br /> Self Service Portal</h2>
                            </div>
                        </Col> */}

            {/* <Col lg={6} md={12} className="right-panel">
                            <div className="form-area p-4 p-md-5"> */}
            {/* <div className="logo text-center">
                                    <img src="./images/logo.svg" alt="spicejet" className="img-fluid" />
                                </div> */}

            <h1 className="mb-lg-3 mt-lg-4 mb-md-3 mt-md-3 pt-3 font-xxxl">
                Register Your <span className="primary-text bold">Employee</span>
            </h1>

            {apiError && <p className="font-sm regular mb-3 text-danger">{apiError}</p>}
            {/* {successMsg && <Alert variant="success" className="font-sm">{successMsg}</Alert>} */}

            <Form className="mt-4">
                {step === "initial" && (<>
                    <Form.Group className="my-3 mt-0 pb-4 mb-0 position-relative">
                        <Form.Label className="font-xl">
                            Employee ID <sup className="primary-text font-md">*</sup>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            className="p-3 font-md dark-grey-text mb-1"
                            placeholder="Enter Employee ID"
                            value={empId}
                            onChange={handleEmpIdChange}
                            //isInvalid={!!empIdError}
                            disabled={step === "otp"}
                        />
                        <div className="font-sm regular mb-3 text-danger position-absolute">
                            {empIdError}
                        </div>
                    </Form.Group>


                    <Form.Group className="my-3 pb-4 mb-0 position-relative">
                        <Form.Label className="font-xl d-block">
                            Date Of Birth <sup className="primary-text font-md">*</sup>
                        </Form.Label>
                        <DatePicker
                            selected={dob}
                            onChange={handleDobChange}
                            className={`form-control w-100 p-3 mb-1 font-md dark-grey-text ${dobError ? "is-invalid" : ""}`}
                            placeholderText="Select Date of Birth"
                            dateFormat="dd/MM/yyyy"
                            maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={15}
                            scrollableYearDropdown
                        />
                        {dobError && (
                            <div className="font-sm regular mb-3 text-danger position-absolute">
                                {dobError}
                            </div>
                        )}
                    </Form.Group>
                </>)}

                {step === "otp" && (
                    <>
                        <Form.Group className="my-3 pb-4 mb-0 position-relative">
                            <Form.Label className="font-xl">
                                Password <sup className="primary-text font-md">*</sup>
                            </Form.Label>
                            <Form.Control
                                type="password"
                                className="p-3 font-md mb-1 dark-grey-text"
                                placeholder="Enter Password"
                                value={password}
                                onChange={handlePasswordChange}
                            //isInvalid={!!passwordError}
                            />
                            {/* <span
                              className="password-toggle-icon position-absolute end-0 me-4 top-0 mt-4 pt-1"
                              onClick={togglePasswordVisibility}
                            >
                              {passwordVisible ? (
                                <img className="icon-24" src="./images/eye-fill.svg" alt="show" />
                              ) : (
                                <img className="icon-24" src="./images/eye-slash.svg" alt="hide" />
                              )}
                            </span> */}
                            <div className="font-sm regular mb-3 text-danger position-absolute">
                                {passwordError}
                            </div>
                        </Form.Group>

                        <Form.Group className="my-3 pb-4 mb-0 position-relative">
                            <Form.Label className="font-xl">
                                Confirm Password <sup className="primary-text font-md">*</sup>
                            </Form.Label>
                            <Form.Control
                                type="password"
                                className="p-3 font-md dark-grey-text"
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                            //isInvalid={!!confirmPasswordError}
                            />
                            <div className="font-sm regular mb-3 text-danger position-absolute">
                                {confirmPasswordError}
                            </div>
                        </Form.Group>

                        <Form.Group className="my-3 position-relative">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <Form.Label className="font-xl mb-0">
                                    OTP <sup className="primary-text font-md">*</sup>
                                </Form.Label>
                                <button
                                    type="button"
                                    className="font-xs link-dark px-0 bg-transparent border-0"
                                    onClick={handleResendOTP}
                                    disabled={!resendEnabled || loading}
                                >
                                    {resendEnabled
                                        ? "Resend OTP"
                                        : `Resend OTP in ${formatTimer(timer)}`}
                                </button>
                            </div>
                            <Form.Control
                                type="text"
                                className="p-3 font-md dark-grey-text"
                                placeholder="Enter 6-digit OTP"
                                value={otp}
                                onChange={handleOtpChange}
                                maxLength={6}
                            //isInvalid={!!otpError}
                            />

                            {/* <div className="font-sm regular mb-3 text-danger position-absolute">
                                {otpError}
                            </div> */}

                            <div className="d-flex justify-content-between align-items-center mt-1" style={{ minHeight: "1.2rem" }}>
                                <div className="font-sm regular text-danger">
                                    {otpError}
                                </div>
                                <p className="font-xs mb-0 success-text">OTP sent on your email</p>
                            </div>
                        </Form.Group>

                        <div className="justify-content-end align-items-end mt-2 mb-2">
                            {/* <button
                                type="button"
                                className="font-xs link-dark px-0 bg-transparent border-0"
                                onClick={handleResendOTP}
                                disabled={!resendEnabled || loading}
                            >
                                Resend OTP {timer > 0 && !resendEnabled && `in ${formatTimer(timer)}`}
                            </button> 
                            <p className="mb-0 success-text">OTP sent on your email</p>
                            */}
                        </div>
                    </>
                )}

                <div className="mt-0">
                    {step === "initial" && (
                        <Button
                            className="btn-primary submit-btn font-xl btn btn-animation w-100 text-uppercase"
                            disabled={!canSendOtp}
                            onClick={() => { handleSendOTP(false) }}
                        >
                            {loading ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" />{" "}
                                    Processing...
                                </>
                            ) : (
                                "Send OTP"
                            )}
                        </Button>
                    )}

                    {step === "otp" && (
                        <Button
                            className="btn-primary submit-btn font-xl btn btn-animation w-100 text-uppercase"
                            disabled={!canCompleteRegistration}
                            onClick={handleCompleteRegistration}
                        >
                            {loading ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" />{" "}
                                    Processing...
                                </>
                            ) : (
                                "Complete Registration"
                            )}
                        </Button>
                    )}
                </div>

                <div className="d-flex mt-3 justify-content-center align-items-center">
                    {/* <Link
                            to={`/${config.baseUrl}/login`}
                            className="font-sm primary-text text-decoration-none"
                        >
                            Back to login
                        </Link> */}
                    <Link type="button" className="d-lg-none d-inline-block font-sm primary-text text-decoration-none" onClick={() => props.setIsSignin(false)}>
                        Back to login
                    </Link>
                </div>
            </Form>
            {/* </div>
                       </Col>
               </Row>
               </div>
             </Container>  */}
            <SuccessModal
                isOpen={successModal}
                onClose={closeSuccessModal}
                message={successMessage}
            />
            {/* </section> */}
        </>
    );
}

export default RegisterEmp;